import { render, staticRenderFns } from "./PrepProcessSort.vue?vue&type=template&id=3038c042"
import script from "./PrepProcessSort.vue?vue&type=script&lang=js"
export * from "./PrepProcessSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports